import { KeyValue } from '@/main/models/common';
import {
    UserHierarchyActionTypes,
    UserHierarchyTypes
} from './userHierarchyTypes';

export function getUserHierarchy(
  guidInsurer: string,
  idSystemApplication: number,
): UserHierarchyActionTypes {
  return {
    type: UserHierarchyTypes.GET_USER_HIERARCHY,
    payload: {
      guidInsurer,
      idSystemApplication
    }
  };
}
export function saveUserHierarchy(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): UserHierarchyActionTypes {
  return {
    type: UserHierarchyTypes.SAVE_USER_HIERARCHY,
    payload: {
      data,
      isError,
      errorMessages
    }
  };
}

export function resetReducerUserHierarchy(): UserHierarchyActionTypes {
  return {
    type: UserHierarchyTypes.RESET_REDUCER_USER_HIERARCHY
  };
}
